import React, { useMemo } from "react";
import { FlatList, Pressable, StyleSheet, Text, View } from "react-native";
import { useNavigation } from "@react-navigation/native";

import { DivineBackground } from "../../shared/ui/DivineBackground";
import { Header } from "../../shared/ui/Header";

type Row = {
  id: string;
  title: string;
  route: string;
  tint: string;
  bg: string;
  icon: React.ReactNode;
};

export function HealthMenuScreen() {
  const navigation = useNavigation<any>();

  const rows = useMemo<Row[]>(
    () => [
      {
        id: "diet",
        title: "Diet Chart",
        route: "DietChart",
        tint: "#059669",
        bg: "rgba(16,185,129,0.14)",
        icon: <Text style={{ fontSize: 18, fontWeight: "900", color: "#059669" }}>🍽️</Text>,
      },
      {
        id: "pranayam",
        title: "Pranayam",
        route: "Pranayam",
        tint: "#0D9488",
        bg: "rgba(13,148,136,0.14)",
        icon: <Text style={{ fontSize: 18, fontWeight: "900", color: "#0D9488" }}>🧘</Text>,
      },
      {
        id: "exercise",
        title: "Exercise",
        route: "Exercise",
        tint: "#0284C7",
        bg: "rgba(2,132,199,0.14)",
        icon: <Text style={{ fontSize: 18, fontWeight: "900", color: "#0284C7" }}>🏋️</Text>,
      },
    ],
    []
  );

  return (
    <DivineBackground overlayOpacity={0.92}>
      <Header title="Health" showBack showProfile />

      <View style={styles.container}>

        <FlatList
          data={rows}
          keyExtractor={(i) => i.id}
          contentContainerStyle={{ paddingBottom: 16 }}
          renderItem={({ item }) => (
            <Pressable
              onPress={() => navigation.navigate(item.route)}
              style={({ pressed }) => [styles.row, pressed && { opacity: 0.92 }]}
            >
              <View style={styles.left}>
                <View style={[styles.bubble, { backgroundColor: item.bg }]}>
                  {item.icon}
                </View>
                <Text style={styles.rowText}>{item.title}</Text>
              </View>

              <Text style={styles.chev}>›</Text>
            </Pressable>
          )}
        />
      </View>
    </DivineBackground>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, paddingHorizontal: 14, paddingTop: 12 },
  pageTitle: { fontSize: 18, fontWeight: "900", color: "#1a4731", marginBottom: 10 },

  row: {
    backgroundColor: "rgba(255,255,255,0.90)",
    borderRadius: 14,
    paddingVertical: 14,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: "rgba(16,185,129,0.18)",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
    shadowColor: "#000",
    shadowOpacity: 0.04,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 6 },
    elevation: 2,
  },
  left: { flexDirection: "row", alignItems: "center", gap: 12 },
  bubble: {
    width: 44,
    height: 44,
    borderRadius: 999,
    alignItems: "center",
    justifyContent: "center",
  },
  rowText: { fontSize: 15.5, fontWeight: "800", color: "#1a4731" },
  chev: { fontSize: 22, fontWeight: "900", color: "rgba(16,185,129,0.55)" },
});